'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');
const TimeInterval=require('pulsar-utils/dist-es6/timeInterval');
const IncidentViewModel=require('../../../dist-es6/client/viewModels/incidentViewModel');
const DutyViewModel=require('../../../dist-es6/client/viewModels/dutyViewModel');
const TripViewModel=require('../../../dist-es6/client/viewModels/tripViewModel');
const BaseZonedIntervalViewModel=require('../../../dist-es6/client/viewModels/baseZonedIntervalViewModel');
const EstimatesAsOfStatusDirective=require('../../../dist-es6/client/directives/estimatesAsOfStatusDirective/estimatesAsOfStatusDirective');
const ErrorMessages=require('../../../dist-es6/client/errorMessages');
const SocketResponse=require('../../../dist-es6/client/dtos/socketResponse');let

ScheduleService=function(_BaseService){_inherits(ScheduleService,_BaseService);_createClass(ScheduleService,null,[{key:'$inject',get:function()
{return['socketService','notificationService']}}]);

function ScheduleService(socketService,notificationService){_classCallCheck(this,ScheduleService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._socketService=socketService;
_this._notificationService=notificationService;return _this;
}ScheduleService.prototype.

getScheduleFor=function(){var ref=_asyncToGenerator(function*(personInfo,interval,timezone){
const personalScheduleResponse=yield this._socketService.sendAndWaitForResponse(
'GetPersonalSchedule',{
queryInterval:interval,
personId:personInfo.id,
activationStatus:personInfo.activationStatus,
timezone:timezone});


if(personalScheduleResponse.status!=='Ok'){
this._notificationService.displayNotification(ErrorMessages.OopsTryAgain,'error');
throw new Error(`'${personalScheduleResponse.status}' loading schedule for ${personInfo.id}`);
}

const personalSchedule=personalScheduleResponse.body;

return{
personId:personalSchedule.personId,
now:personalSchedule.now,
queryInterval:new TimeInterval(personalSchedule.queryInterval),
estimatesAsOfTime:SocketResponse.safeDeserializeDate(personalSchedule.estimatesAsOfTime),
duties:personalSchedule.duties.map(function(d){return new DutyViewModel(d)}),
trips:personalSchedule.trips.map(function(t){return new TripViewModel(t)}),
bounds:_timeIntervalOrNull(personalSchedule.bounds),
sleep:personalSchedule.sleep.map(function(s){return new BaseZonedIntervalViewModel(s)}),
sleepPromotingIntervals:personalSchedule.sleepPromotingIntervals.map(function(s){return new BaseZonedIntervalViewModel(s)}),
incidents:personalSchedule.incidents.map(function(incident){return IncidentViewModel.createFrom(incident,incident,timezone,_.noop)}),
fatigue:_deserializeFatigue(personalSchedule.fatigue),
forecastFatigue:_deserializeFatigue(personalSchedule.forecastFatigue),
predictedWorkday:_timeIntervalOrNull(personalSchedule.predictedWorkday),
dailyEffectiveStatuses:personalSchedule.dailyEffectiveStatuses};

});function getScheduleFor(personInfo,interval,timezone){return ref.apply(this,arguments)}return getScheduleFor}();return ScheduleService}(BaseService);


function _deserializeFatigue(fatigue){
if(!fatigue){
return[];
};

return fatigue.map(function(fp){return{
time:SocketResponse.safeDeserializeDate(fp.time),
value:fp.value}});

}

function _timeIntervalOrNull(interval){
return interval?new TimeInterval(interval):null;
}

module.exports=ScheduleService;
//# sourceMappingURL=scheduleService.js.map
